<template>
  <ion-header translucent>
    <ion-toolbar>
      <ion-buttons slot="start" fill="outline" >
        <ion-button v-on:click="onOK(selectedList)" color="primary" style="min-width: 5em">OK</ion-button>
      </ion-buttons>
      <ion-title style="text-align: center">Select {{dataKey}}</ion-title>
      <ion-buttons slot="end">
        <ion-button v-on:click="onCancel()">Cancel</ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar>
      <ion-searchbar v-on:ionChange="search($event.detail.value)"></ion-searchbar>
    </ion-toolbar>
  </ion-header>
  <ion-content fullscreen>
    <ion-list style="width: 100%">
      <ion-item v-for="eq in data" v-bind:key="eq.code">
        <ion-checkbox style="margin-right: 1em" v-on:ionChange="toggleSelectItem(eq)" :checked="isSelected(eq)"></ion-checkbox>
        <ion-label>{{ eq.name }}</ion-label>
        <ion-chip v-if="withPreference && isSelected(eq)">{{getPrefIndex(eq)}}</ion-chip>
      </ion-item>
      <ion-item v-if="showOtherOption">
        <ion-checkbox style="margin-right: 1em" v-on:ionChange="toggleSelectItem(oth)" :checked="isSelected(oth)"></ion-checkbox>
        <ion-label>{{ oth.name }}</ion-label>
        <ion-chip v-if="withPreference && isSelected(oth)">{{getPrefIndex(oth)}}</ion-chip>
      </ion-item>
    </ion-list>
  </ion-content>
  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="start" v-if="multiSelect">
        <ion-button v-on:click="onOK(selectedList)" color="primary" style="min-width: 5em">OK</ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button v-on:click="onCancel()">Cancel</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</template>

<script>
import {
  IonSearchbar,
  IonCheckbox,
  IonButtons,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonContent,
  IonChip,
  loadingController,
  modalController
} from '@ionic/vue';

import eoppService from "@/mixins/EoppService";
import { defineComponent } from 'vue';
// export default {


export default defineComponent({
  name: 'DataListSelect',
  components: {
    IonSearchbar,
    IonCheckbox,
    IonButtons,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    IonContent,
    IonChip,
  },
  mixins: [eoppService],
  data() {
    return {
      orgData: null,
      data: [],
      selectedList: [],
      oth: {
        code: 'oth',
        name: 'Other'
      },
    };
  },
  props: {
    dataKey: {type: String},
    code: {type: String},
    multiSelect: {type: Boolean, default: false},
    current: {type: Object},
    items: {type: Object},
    showOtherOption: {type: Boolean, default: false},
    withPreference: {type: Boolean, default: false},
  },
  mounted() {
    if (this.dataKey) {
      this.loadItems()
    } else if (this.items){
      this.data = this.items.slice(0);
      this.orgData = this.items.slice(0);
      this.preSelectCurrent();
    }
  },

  // computed :{
  // hasDocRules() {
  //   return this.doctype.rules && this.doctype.rules.length > 0;
  // }
  // },
  methods: {
    loadItems: function () {
      this.presentLoading();
      this.getData(`/data?key=${this.dataKey}${this.code ? '&code=' + this.code : ''}`).then(res => {
        loadingController.dismiss();
        if (res && res.data) {
          // @ts-ignore
          res.data.sort((a, b) => a.name.localeCompare(b.name));
          this.data = res.data;
          this.orgData = this.data.slice(0);
        }
        // this.quizItem.options = res;
        // this.initPreviousAnswer();
        this.preSelectCurrent();
      })
    },
    preSelectCurrent: function () {
      (this.current || []).forEach(o => {
        let it = this.data.find(x => x.code === o.code);
        if (it) {
          this.selectedList.push(it);
        }
      })
    },
    toggleSelectItem: function (item) {
      if (this.multiSelect) {
        let idx = this.selectedList.indexOf(item);

        if (idx >= 0) {
          this.selectedList.splice(idx, 1);
        } else {
          this.selectedList.push(item);
        }
      } else {
        this.onOK(item);
      }
    },
    onCancel: function () {
      modalController.dismiss();
    },
    onOK: function (item) {
      modalController.dismiss(item);
    },
    search: function (str) {
      if (str && str.length > 0) {
        this.data = this.orgData.filter(o => o.name.toLowerCase().indexOf(str.toLowerCase()) >= 0);
      } else {
        this.data = this.orgData.slice(0);
      }
    },
    presentLoading: async function () {
      const loading = await loadingController
          .create({
            cssClass: 'my-custom-class',
            message: 'Please wait...',
            duration: 2000,
          });

      await loading.present();

      setTimeout(function () {
        loading.dismiss()
      }, 2000);
    },
    isSelected: function (eq) {
      return this.selectedList.includes(eq);
    },
    getPrefIndex: function (opt) {
      let idx = (this.selectedList || []).indexOf(opt);
      if (idx === 0) {
        return '1st';
      } else if (idx === 1) {
        return '2nd';
      } else if (idx === 2) {
        return '3rd';
      } else {
        return `${(idx + 1)}th`;
      }
    }
  }
})
</script>
<style>

</style>
